import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { MantineProvider, createTheme } from "@mantine/core";
import Home from "./pages/Home/Home";
import News from "./pages/News/News";
import Welcome from "./pages/Welcome/Welcome";
import Layout from "./components/Layout/Layout";

import "@mantine/core/styles.css";
import CXGenieBot from "./pages/CXGenieBot/CXGenieBot";
import JotformBot from "./pages/JotformBot/JotformBot";
import IntercomBot from "./pages/IntercomBot/IntercomBot";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { useMyChats } from "./api/queries";

const theme = createTheme({
  fontFamily: "Manrope, sans-serif",
});

function App() {
  const { data } = useMyChats();

  console.log(data);
  return (
    <MantineProvider theme={theme} defaultColorScheme="dark">
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <AuthenticatedTemplate>
                  <Home />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <Welcome />
                </UnauthenticatedTemplate>
              </Layout>
            }
          />
          <Route
            path="/news"
            element={
              <Layout>
                <AuthenticatedTemplate>
                  <News />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <Welcome />
                </UnauthenticatedTemplate>
              </Layout>
            }
          />
          <Route
            path="/cxgenie"
            element={
              <Layout>
                <AuthenticatedTemplate>
                  <CXGenieBot />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <Welcome />
                </UnauthenticatedTemplate>
              </Layout>
            }
          />
          <Route
            path="/jotform"
            element={
              <Layout>
                <AuthenticatedTemplate>
                  <JotformBot />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <Welcome />
                </UnauthenticatedTemplate>
              </Layout>
            }
          />
          <Route
            path="/intercom"
            element={
              <Layout>
                <AuthenticatedTemplate>
                  <IntercomBot />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                  <Welcome />
                </UnauthenticatedTemplate>
              </Layout>
            }
          />
        </Routes>
      </Router>
    </MantineProvider>
  );
}

export default App;
